<template>
  <label class="img-cont" :style="{width: width + 'px',  height: height + 'px'}">
    <div class="img-wrap"
         :style="{width: width + 'px', maxWidth: width + 'px', height: height + 'px', maxHeight: height + 'px'}">
      <img :src="imgUrl"
           v-if="imgUrl && !avatar"
           class="avatar">
      <img :src="avatar"
           class="avatar"
           v-if="avatar">
      <project-icon v-if="isProject && !avatar && !imgUrl"></project-icon>
      <group-icon v-if="!avatar && !imgUrl && !isProject"></group-icon>
    </div>
    <input :disabled="!editable"
           :readonly="!editable"
           type="file"
           @change="addAvatar">
    <div
            v-if="editable"
            @click="delAvatar"
            class="edit-btn">
      <del-icon v-if="avatar || imgUrl"
                :fill="'rgba(0, 82, 127, 1)'"></del-icon>
      <photo-icon v-else></photo-icon>
    </div>
    <errors class="size"
            v-show="error"
            min-length="1,5"
            :type="'fileSize'"></errors>
  </label>
</template>

<script>
  import groupIcon from './Svg/users/group'
  import editIcon from './Svg/editIcon'
  import errors from './Forms/errors'
  import delIcon from './Svg/cart_control/delIcon'
  import projectIcon from './Svg/dashboard/prjectsIcon'
  import photoIcon from './Svg/photoIcon'

  export default {
    name: 'avatarCont',
    props: {
      imgUrl: {
        type: String,
      },
      width: {
        type: Number,
        default: 100
      },
      height: {
        type: Number,
        default: 100
      },
      editable: {
        type: Boolean,
        default: true
      },
      isProject: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      groupIcon,
      editIcon,
      errors,
      delIcon,
      projectIcon,
      photoIcon
    },
    data() {
      return {
        error: false,
        avatar: '',
      }
    },
    methods: {
      addAvatar(e) {
        const fileList = e.target.files;
        const thisFile = fileList[fileList.length - 1];
        const imgSize = thisFile.size;
        const maxSizeMB = 1572864;

        if (imgSize < maxSizeMB) {
          if (!!thisFile) {
            let cntx = this;
            const reader = new FileReader();

            reader.onload = function (event) {
              const contents = event.target.result;
              cntx.avatar = contents;
            };

            reader.readAsDataURL(thisFile);
            this.$emit('upload', thisFile);
          }
        } else {
          this.error = true;
          setTimeout(() => this.error = false, 3000)
        }
      },
      delAvatar() {
        this.avatar = '';
        this.imgUrl = '';
        this.$emit('del')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .img-cont {
    position: relative;
    display: flex;
  }

  .img-wrap {
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 12px rgba(0, 82, 127, 0.2);
    width: 100%;
    height: 100%;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
    }

    svg {
      max-width: 70%;
    }

  }

  img {
    width: auto;
    height: 100%;
  }

  .edit-btn {
    width: 24px;
    height: 24px;
    background: white;
    border-radius: 50%;
    position: absolute;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.08);
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  input {
    position: absolute;
    width: 0;
    height: 0;
    z-index: -999;
    opacity: 0;
  }

  .size {
    position: absolute;
    white-space: nowrap;
  }
</style>
